import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class AppSettings {
    //Provide all the Application Configs here

    public overRideHost: boolean = true;
    public globalErrorRouting: boolean = false;
    public serverHost: string = environment.serverHost;
    public tokenServerContext: string = environment.tokenServerContext;
    public serverContext: string = environment.serverContext;
    public serverContextPath: string = environment.serverContextPath;
    public port: string = environment.port;
    public enableOrganization: boolean = true;
    public sessionTimeoutInMinutes = 30
    public httpConstants: object = {
        applicationID: "portal",
    }
    public apiVersion = "1.0.0"
    public enableHttpUrlConfig: boolean = false;
    public defaultLocale: string = "en-US";
    public currencyFormat = { style: "currency", currency: "USD" };
    public dateFormat = { year: 'numeric', month: '2-digit', day: '2-digit' } as const;
    public operationalModules = ['Product Configurator', "Claims", 'Dev']
    public operationalModulesForNBU = ['New Business', "Claims", 'Underwriting', 'Agent Portal', 'Dev']
    public operationalModules1 = ['New Business']
    public LineOfBusiness = [
        {
            moduleName: 'New Business',
            LOBSupport: ['HEALTH']
        }
    ]

    public entryPoints = [{
        viewModule: "Claims",
        roleCd: 'default',
        entryPoint: "/app/claims/inbox/search-config"
    }, {
        viewModule: "Claims",
        roleCd: "CLAIM_INVESTIGATION",
        entryPoint: "/app/claims/inbox/partner-inbox"
    },
    {
        viewModule: "New Business",
        roleCd: 'default',
        entryPoint: "/app/nbu/inbox/workbench"
    },
    {
        viewModule: "New Business",
        roleCd: 'NBDATAENTRY',
        //entryPoint: "/app/nbu/proposal/search",
        entryPoint: "/app/nbu/inbox/workbench"
    },
    {
        viewModule: "AgentHierarchy",
        roleCd: 'default',
        entryPoint: "/app/org-agents"
    },
    {
        viewModule: "Policy Servicing",
        roleCd: 'default',
        entryPoint: "/app/policyServicing/search-policy"
    },
    ]

    HEALTHLOB = true;
    MOTORLOB = false;
    PROPERTYLOB = false;
    TRAVELLOB = false;
    constructor() {
    }
}
